import React from 'react'
import { isNil } from 'ramda'
import { useNavigate } from 'react-router-dom'
import { Pill, Row } from 'sidecar-components'
import { formatDate } from 'sidecar-utilities'
import { getTicketStatus } from 'sidecar-member-components/utils'

import {
  descriptionStyles,
  mainContentStyles,
  pillStyles,
  rowStyles,
  rowChildrenStyles,
  timeStyles,
  titleAndDescStyles,
  titleStyles,
} from './styles'

export const RequestRow = ({
  bolded = false,
  href,
  onClick,
  members,
  request,
  selected = false,
  setActiveRequest,
  fetchSingleCommsMessage,
}) => {
  const navigate = useNavigate()
  const { customerTitle, comments, ticketKey, status, mostRecentComment } =
    request
  const updated = formatDate(
    'MM/DD/YYYY',
    comments[comments.length - 1].updated,
  )
  const { status: pillStatus, sentiment } = getTicketStatus(status)

  // Member facing id removes the Jira project name
  // MEMBER-1234 => 1234
  const id = ticketKey.split('-')[1]

  // On the detail page, clicking a row should run a function that switches out the message.
  // If the user is already on that message, the row should be disabled.
  // On the list page, there should not be an onClick because the row should be a link that
  // navigates the user to the detail page instead.

  return (
    <Row
      testId={`link_${ticketKey}`}
      childrenClass={rowChildrenStyles}
      // If there is an onClick, that means you are on the detail page
      // and we don't need to show the chevron on the side bar
      className={rowStyles({ hideChevron: !!onClick, selected })}
      onClick={e => {
        e.preventDefault()
        fetchSingleCommsMessage(request.ticketId)
        setActiveRequest(request)
        navigate(href)
      }}
    >
      <div className={mainContentStyles}>
        <div className={titleAndDescStyles}>
          <div className={titleStyles({ selected, bolded })}>
            {customerTitle ? customerTitle : 'General message'}
          </div>

          {!!mostRecentComment && (
            <div className={descriptionStyles}>{mostRecentComment}</div>
          )}

          <div className={descriptionStyles}>
            {!isNil(members) && members.length > 1 && (
              <>
                <span data-testid="info_messageMember">
                  For {request.firstName}
                </span>
                {' • '}
              </>
            )}
            <span data-testid="info_messageId">ID #{id}</span>
          </div>
        </div>
        <Pill
          testId={`info_status_${ticketKey}_${status.split(' ').join('_')}`}
          text={pillStatus}
          sentiment={sentiment}
          className={pillStyles}
        />
      </div>

      <time
        className={timeStyles}
        data-testid="info_createdAt"
        dateTime={updated}
      >
        {formatDate('MM/DD/YY', updated)}
      </time>
    </Row>
  )
}
